module.exports = __webpack_public_path__ + "static/media/LETO ULTRA II PREAMPLIFIER.12b2a3a5.png";